<button class="btn btn-warning" (click)="composeSetitem()">{{ 'COMPOSE_SETITEM' | translate }}</button>
